import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

export const ScrollToTop = () => {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    const root = document.documentElement;
    const prevScrollBehavior = root.style.scrollBehavior;
    
    // Disable smooth scrolling temporarily for instantaneous route navigation jump
    root.style.scrollBehavior = "auto";
    window.scrollTo(0, 0);
    root.scrollTop = 0;
    document.body.scrollTop = 0;

    // Restore original scroll behavior so intentional in-page smooth scrolling works
    const timer = setTimeout(() => {
      root.style.scrollBehavior = prevScrollBehavior;
    }, 0);

    return () => clearTimeout(timer);
  }, [pathname]);

  return null;
};
